import memoize from 'memoize-one';
export const getUsers = memoize((state) => {
    const userStore = state.get('userStore');
    const users = userStore.get('users');
    return users;
});
